import { render } from "./AddUsuarioB2B.vue?vue&type=template&id=5df7cd34&scoped=true"
import script from "./AddUsuarioB2B.vue?vue&type=script&lang=js"
export * from "./AddUsuarioB2B.vue?vue&type=script&lang=js"

import "./AddUsuarioB2B.vue?vue&type=style&index=0&id=5df7cd34&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df7cd34"]])

export default __exports__